module.exports = __webpack_public_path__ + "images/shimo/sheet-grid-5b579137d887169733de8bb765250584.png";